import { useEffect, useState } from "react"

import { Card, Layout, message, Spin, Statistic, Tooltip, Typography } from "antd"
import cls from "classname"
import { useTranslation } from "react-i18next"
import { connect } from "react-redux"
import { useLocation, useNavigate } from "react-router"
import { Link } from "react-router-dom"

import ButtonComponent from "../Components/Button"
import LoginHeader from "../Components/LoginHeader"
import LogOutText from "../Components/LogOutText"
import PrivacyPolicy from "../Components/PrivacyPolicy"
import Icon from "../Icon"
import Images from "../Images"
import { defaultInnerPage } from "../Utils/appRoutes"
//import StepTitle from '../Components/StepTitle/StepTitle'

import utils from "../Utils/utils"
import { authErrorReset } from "./LoginPage/redux/auth.actions"
import { resendVerificationLink } from "./LoginPage/redux/auth.thunks"

const { Countdown } = Statistic
const { Text } = Typography

function CheckMailboxPage(props) {
  const { error, resetError, fetching, userInfo } = props

  const location = useLocation()
  const { state } = location

  const { t } = useTranslation()
  const navigate = useNavigate()

  const [errorText, setErrorText] = useState(null)

  const [resendFetching, setResendFetching] = useState(false)
  const [deadline, setDeadline] = useState(null)

  const email = userInfo?.email || state

  useEffect(() => {
    document.title = "Confirm Email - Chargeback"
    if (!userInfo) {
      navigate("/login")
    } else if (userInfo?.new_onboarding_finished || userInfo?.onboarding_finished) {
      navigate(defaultInnerPage)
    }
    /*eslint-disable-next-line react-hooks/exhaustive-deps*/
  }, [])

  useEffect(() => {
    if (error) {
      if (error.message) {
        setErrorText(Object.values(error.message)[0])
      } else if (typeof error === "string") {
        setErrorText(error)
      } else {
        for (let i in error) {
          message.error(`${i}: ${error[i]}`, 5)
        }
      }
      resetError()
    }
    /*eslint-disable-next-line react-hooks/exhaustive-deps*/
  }, [error])

  function handleResendEmail() {
    if (email) {
      setDeadline(Date.now() + 1000 * 60)
      setResendFetching(true)
      props.resendVerificationLink({ email })
    }
  }

  function onFinish() {
    setResendFetching(false)
    setDeadline(null)
  }

  return (
    <Layout>
      <Spin size="large" spinning={fetching}>
        <div className="login-row">
          <LoginHeader />
          <div className="login-content">
            <div className="content-main sign-up">
              {/*<StepTitle maxStep={7} step={2}/>*/}

              <Card className="login-card" style={{ margin: "auto 0" }}>
                <h2 className="card-title" style={{ marginBottom: 12 }}>
                  {t("Confirm email")}
                </h2>
                <h4 className="card-subtitle-signup" style={{ margin: 0 }}>
                  {t("Confirmation letter has been sent to")} <Text>{email}</Text>{" "}
                  <Tooltip title={t("Change email")}>
                    {/*<Button type="link" size="small"
                                icon={<Icon role="icon" type="edit" />}
                                href={'/sign-up'}

                        />*/}
                    <Link to={"/sign-up"} state={"change_email"}>
                      <Icon role="icon" type="edit" />
                    </Link>
                  </Tooltip>
                </h4>

                <div className={cls("error-text", { "error-text_empty": !errorText })}>
                  {errorText}
                </div>

                <Text type="secondary">
                  {t(
                    "If you don’t see it in Inbox, try the Junk Mail/Spam folder. Otherwise, make sure you entered the same e-mail address you used to sign in."
                  )}
                </Text>

                <div className="verify-btn-block">
                  <ButtonComponent
                    size="large"
                    href={`https://mail.${utils.checkMailDomain(email).link}.com`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex center"
                    block
                  >
                    <img
                      height={20}
                      className="btn-icon icon-space"
                      src={Images[utils.checkMailDomain(email).type]}
                      alt=""
                    />
                    {t("Go To")} {utils.checkMailDomain(email).name}
                  </ButtonComponent>
                </div>

                <div className="sign-up-link check-mail" style={{ justifyContent: "center" }}>
                  {resendFetching ? (
                    <div className="resend-timer">
                      <Countdown
                        title=""
                        value={deadline}
                        onFinish={onFinish}
                        format="mm:ss"
                        prefix={<span>{t("You will able to resend link in")} </span>}
                        //suffix={<span> {t('Sec...')}</span>}
                      />
                      <Spin />
                    </div>
                  ) : (
                    <span>
                      {`${t("Didn’t receive a link?")} `}
                      <span className="text-link" onClick={handleResendEmail}>
                        {t("Resend Link")}
                      </span>
                    </span>
                  )}
                </div>
              </Card>

              <PrivacyPolicy />
              <LogOutText />
            </div>
          </div>
        </div>
      </Spin>
    </Layout>
  )
}

const mapStateToProps = (state) => {
  return {
    //isMobile: state.nav.isMobile,
    error: state.auth.error?.message,
    fetching: state.auth.fetching,
    userInfo: state.auth.userInfo
  }
}

const mapDispatchToProps = (dispatch) => ({
  resendVerificationLink: (data) => dispatch(resendVerificationLink(data)),
  resetError: () => dispatch(authErrorReset())
})

export default connect(mapStateToProps, mapDispatchToProps)(CheckMailboxPage)
